import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../../actions';
import { showToast } from '../../../services/toast';

const ForgotPassword = () => {
    const [username, setUsername] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [formMessage, setFormMessage] = useState('');
    const [formMessageType, setFormMessageType] = useState('');
    const [linkSent, setLinkSent] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);
    const dispatch = useDispatch();
    const branding = useSelector((state) => state.organization?.branding);
    const bgStyle = branding?.cmsLoginBgUrl
        ? { backgroundImage: `url(${branding.cmsLoginBgUrl})` }
        : undefined;

    const handleChange = (e) => {
        setUsername(e.target.value);
        setFormMessage('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isSubmittingRef.current || linkSent) {
            return;
        }
        setSubmitted(true);
        setFormMessage('');

        if (!username) {
            setFormMessage('Email Address is required');
            setFormMessageType('error');
            return;
        }

        isSubmittingRef.current = true;
        setIsSubmitting(true);
        dispatch(userActions.forgotPassword(username))
            .then(() => {
                const successText = 'Password reset link sent to your registered Email.';
                showToast(successText, 'success');
                setFormMessage(successText);
                setFormMessageType('success');
                setLinkSent(true);
                isSubmittingRef.current = false;
                setIsSubmitting(false);
            })
            .catch((error) => {
                isSubmittingRef.current = false;
                setIsSubmitting(false);
                const message = error?.message || String(error);
                setFormMessage(message);
                setFormMessageType('error');
                if (!error?.alreadyShownToast) {
                    showToast(message, 'error');
                }
            });
    };

    return (
        <React.Fragment>
            <div className='login-bgimage' style={bgStyle}>
                <div className="col-sm-8 col-sm-offset-2">
                    <div className='row' style={{ marginTop: '120px' }}>
                        <div className="col-md-6" />
                        <div className="col-md-6 card bg-white">
                            <h3 style={{ textAlign: 'center' }}>Forgot Password</h3>
                            <form name="form" onSubmit={handleSubmit}>
                                <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                                    <label htmlFor="username">Email Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="username"
                                        value={username}
                                        onChange={handleChange}
                                        disabled={isSubmitting || linkSent}
                                    />
                                    {submitted && !username &&
                                        <div className="text-danger mt-1">Email Address is required</div>
                                    }
                                </div>
                                {formMessage && (
                                    <div className={`alert ${formMessageType === 'success' ? 'alert-success' : 'alert-danger'}`}>
                                        {formMessage}
                                    </div>
                                )}
                                <div className="form-group">
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting || linkSent}>
                                        {isSubmitting ? 'Sending...' : linkSent ? 'Link sent' : 'Send Reset Link'}
                                    </button>
                                    <Link to='/login' className='pull-right mt-10 mr-10'>Login</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ForgotPassword;